<template>
  <div class="po-r w100 bg-w card-shadow">
    <el-row class="w100 bor-b card-title">
      <el-col class="pl20" :span="18">
        <p class="font-16 blue">服务发起排名</p>
      </el-col>
    </el-row>

    <div class="w100 pt10 pb20 pl20 pr20" v-loading="loading">
      <div class="mb10">
        <el-button size="mini" type="primary" :plain="plain != 'all'" round @click="fetchList(0)">全部</el-button>
        <el-button size="mini" type="primary" :plain="plain != 'day'" round @click="fetchList(1)">今日</el-button>
        <el-button size="mini" type="primary" :plain="plain != 'week'" round @click="fetchList(2)">本周</el-button>
        <el-button size="mini" type="primary" :plain="plain != 'month'" round @click="fetchList(3)">本月</el-button>
        <el-button size="mini" type="primary" :plain="plain != 'year'" round @click="fetchList(4)">本年</el-button>
      </div>

      <el-table class="w100 tx-c my-table" :data="list" stripe border>
        <el-table-column align="center" label="序列" type="index" width="50"></el-table-column>
        <el-table-column align="center" label="类型" prop="name"></el-table-column>
        <el-table-column align="center" label="发起数" prop="num"></el-table-column>
        <el-table-column align="center" label="完成率">
          <template slot-scope="scope">
            {{ (scope.row.compRate * 100).toFixed(2) }}%
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardServeRank",
  props: {},
  data() {
    return {

      loading: false,
      plain: "all",
      list: []
    };
  },
  computed: {},
  mounted() {
    this.fetchList("all");
  },
  methods: {
    fetchList(type) {
      this.plain = type;
      this.loading = true;

      this.$http
        .post(
          "serve/getServeRank",
          this.$qs.stringify({
            range: type,
            limit: 5
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == "0") {
            this.list = data.resData.list;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>
